'use strict';
(function () {
    angular.module('AngularAdmin').directive('stickyHeaderTable', ['$parse', '$timeout', '$window', function($parse, $timeout, $window) {
        return {
            link: function(scope, element, attrs) {
                var model = $parse(attrs.data);
                var scheduled;


                function adjustRowHeight() {
                    var measured_cells = element.find('.sticky-header-measured-row .sticky-header-measured-cell');
                    var adjusted_cells = element.find('.sticky-header-adjusted-row .sticky-header-measured-cell');

                    if(measured_cells.length != adjusted_cells.length) {
                        console.warn("Number of elements in tables does not match", measured_cells, adjusted_cells);
                        return;
                    }

                    for(var i = 0; i < adjusted_cells.length; i++) {
                        measured_cells[i].style.height = 'auto';
                        adjusted_cells[i].style.height = 'auto';
                    }

                    for(var i = 0; i < adjusted_cells.length; i++) {
                        var a = adjusted_cells.eq(i);
                        var b = measured_cells.eq(i);
                        var height = Math.max(a[0].offsetHeight, b[0].offsetHeight);
                        a.outerHeight(height);
                        b.outerHeight(height);
                    }

                    /*element.find('.sticky-header-measured-row tr').each(function(index, tr) {
                        //var $measured = $(tr).children(':not([rowspan])').first();
                        var height = tr.offsetHeight //$measured.outerHeight();

                        if(true) {
                            //if (window.getComputedStyle($measured[0])['borderBottomWidth'] == '0.5px') {
                            //height -= 2;
                            //}

                            adjusted.eq(index).children(":not([rowspan])").first().outerHeight(height);
                        } else {
                            console.log('measured element not found')
                        }
                    });*/
                    scheduled = false;
                }

                function scheduleRowHeight() {
                    if(scheduled) $timeout.cancel(scheduled);
                    scheduled = $timeout(adjustRowHeight);
                }

                scope.$watchCollection(model, scheduleRowHeight);

                angular.element($window).bind('resize', scheduleRowHeight);
            }
        }
    }]);
})();